import React from "react";

const JumboDialogContext = React.createContext({dialogVisibility: false});

export default JumboDialogContext;